import React from 'react';
import './post info.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon} from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { message,Image, Carousel} from "antd";
import moment from "moment";

class postInfo extends React.Component {
    state = {
        actionType:this.props.location.state.actionType?this.props.location.state.actionType==="EDIT"?"EDIT":"VIEW":"VIEW",
        id:this.props.location.state.data.id,
        content:this.props.location.state.data.content?this.props.location.state.data.content:allStrings.notExist,
        createdAt:this.props.location.state.data.createdAt?this.props.location.state.data.createdAt:allStrings.notExist,
        type:this.props.location.state.data.type,
        privacy:this.props.location.state.data.privacy,
        status:this.props.location.state.data.status,
        owner:this.props.location.state.data.owner,
        likesCount:this.props.location.state.data.likesCount,
        commentsCount:this.props.location.state.data.commentsCount,
        gift:this.props.location.state.data.gift?this.props.location.state.data.gift:null,
        occasion:this.props.location.state.data.occasion?this.props.location.state.data.occasion:null,
        location:this.props.location.state.data.location?this.props.location.state.data.location:[],
        media:this.props.location.state.data.media?this.props.location.state.data.media:null,
        
        loading:true,
        imgName:'',
        imgType:'url',
        files:this.props.location.state.data.files,
        images:[]
    };

    constructor(props){
        super(props)
        console.log("ssss",this.props.location.state)
        window.scrollTo(0,0)
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    componentDidMount(){
        console.log("ssss",this.props.location.state)
        let images =[];
        if(this.props.location.state.data.type === "IMAGE"){
            this.props.location.state.data.files.forEach(element => {
                images.push(element.link)
            });
        }
        this.setState({images: images});
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }
    delete = () => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}posts/${this.props.location.state.data.id}`,{
         headers: {
           'Content-Type': 'application/json',
           'Authorization':`Bearer ${this.props.currentUser.token}`,
           'Accept-Language':this.props.isRTL?'ar':'en'
         },
        })
        .then(response=>{
          console.log("post DELETED")
          l.then(() => message.success(allStrings.done, 2.5) )
          this.props.history.goBack() 
        })
        .catch(error=>{
            console.log(error.response)
            l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
        })
    }
   

    

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    imageSection = () =>{
      return(
        <MDBCol  xl ="4" lg = "5"  md="12" sm="12">
          <div className="infoCard">
              <div style={{width:"100%" ,padding:'10px'}}>
                {this.state.type === "IMAGE"&&
                <Image
                  width="100%"
                  placeholder={true}
                  style={{borderRadius:'6px',width:"100%",height:'280px'}} 
                  src={this.state.images}
                />
                }
                {this.state.type === "VIDEO"&&
                <Carousel autoplay>
                    {this.state.files.map((val,index)=>(
                        <div>
                            <video width="100%" height="300px" controls>
                                <source src={val.link} type="video/mp4"/>
                                <source src={val.link} type="video/ogg"/>
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    ))}
                </Carousel>
                }
                
              </div>
          </div>
        </MDBCol>
      )
    }
    
  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('postS')) return <Redirect to='/Home' />

  return (
    <div className="App">
        <MDBContainer> 
            <MDBRow>  
                <MDBCol xl={this.state.type==="IMAGE"?"8":this.state.type==="VIDEO"?"8":"12"} lg = {this.state.type==="IMAGE"?"7":this.state.type==="VIDEO"?"7":"12"} md="12" sm="12">
                    <div className="infoCard">
                        <Card className="editCard" style={{overflow: 'visible',outline:'none',marginBottom:'0px'}}>
                            <CardMedia
                            style={{height:"0px"}}
                            />
                            <CardHeader></CardHeader>
                            <div style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                                <div className="topIcon" style={{background:'#117183'}}>
                                    <span className="material-icons" style={{color:'white',fontSize:23}}>event</span>
                                </div>
                                <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                                marginLeft:this.props.isRTL?'0':'0rem',marginRight:this.props.isRTL?'0rem':'0'}}>
                                <p>{this.state.actionType ==="VIEW"?allStrings.info:allStrings.edit}</p>
                                </div>
                            </div>
                            <CardContent style={{minHeight:"390px",outline:'none'}}>
                                <MDBContainer>
                                    
                                    <MDBRow>
                                        <MDBCol md="12">
                                        <form
                                        className="needs-validation"
                                        noValidate
                                        >
                                        <div className="grey-text">
                                            {this.state.actionType ==="VIEW"&&
                                            <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form8" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>#</label>
                                                    <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.id} type="text" id="form8" className="form-control" validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form86" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.type}</label>
                                                    <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} 
                                                    value={this.state.type==="TEXT"?allStrings.text:this.state.type==="IMAGE"?allStrings.image:
                                                        this.state.type==="VIDEO"?allStrings.video:this.state.type==="RECORD"?allStrings.record:this.state.type==="FILE"?allStrings.file:
                                                        this.state.type==="GIFT"?allStrings.gift:this.state.type==="OCCASION"?allStrings.occasion:
                                                        this.state.type==="MUSIC"?allStrings.music:this.state.type==="MOVIE"?allStrings.movie:allStrings.location} type="text" id="form86" className="form-control" validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            }
                                            {this.state.actionType ==="VIEW"&&
                                            <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form8" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.likesCount}</label>
                                                    <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.likesCount} type="text" id="form8" className="form-control" validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form86" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.commentsCount}</label>
                                                    <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} 
                                                    value={this.state.commentsCount} type="text" id="form86" className="form-control" validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            }
                                            <MDBRow style={{flexFlow:this.props.isRTL?'row-reverse':'row'}}>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.createdAt}</label>
                                                    <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={moment(this.state.createdAt).format('lll')} type="text" id="form645" name="createdAt" className="form-control" validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.status}</label>
                                                    <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.status==="ACTIVE"?allStrings.active:allStrings.notActive} type="text" id="form645" name="createdAt" className="form-control" validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            {this.state.content&&this.state.type === "TEXT"&&
                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <div className="md-form">
                                                    <label htmlFor="form920" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.content}</label>
                                                    <br></br>
                                                    <textarea disabled={this.state.actionType==="VIEW"?true:false} name="content" value={this.state.content} 
                                                    style={{border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} 
                                                    type="text" id="form920" className="form-control" required validate   />
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            }
                                            {this.state.actionType ==="VIEW"&&
                                            <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                                <MDBCol md="10" xs="10">
                                                    <div class="md-form">
                                                    <label htmlFor="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.owner}</label>
                                                    <br></br>
                                                    <div style={{textAlign:this.props.isRTL?'right':'left'}}>
                                                    <p style={{borderBottom: '1px solid #dedede',width:'81%',padding:'10px',paddingBottom: '14px',fontSize: '16px',fontWeight: 400,color: '#000',display: 'inline-block'}}>
                                                        {this.state.owner?this.state.owner.fullname:''}
                                                    </p>
                                                        <img style={{width: '50px',height: '50px',borderRadius: '50%',border:' 2px solid #117183'}} alt="" src={this.state.owner.img?this.state.owner.img:require('../../assets/images/profileicon.jpg')}/>
                                                    </div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="2" xs="2">
                                                <br></br>
                                                <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                                    <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                                    onClick={()=>{this.props.history.push('userInfo',{data:this.state.owner}) }}>
                                                    remove_red_eye
                                                    </span>
                                                    <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                                    onClick={()=>{this.props.history.push('userInfo',{data:this.state.owner}) }}>
                                                    {allStrings.show}
                                                    </span> 
                                                </p>
                                                </MDBCol>
                                            </MDBRow>
                                            }
                                            {this.state.actionType ==="VIEW"&&this.state.gift&&
                                            <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                                <MDBCol md="10" xs="10">
                                                    <div class="md-form">
                                                    <label htmlFor="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.gift}</label>
                                                    <br></br>
                                                    <div style={{textAlign:this.props.isRTL?'right':'left'}}>
                                                    <p style={{borderBottom: '1px solid #dedede',width:'81%',padding:'10px',paddingBottom: '14px',fontSize: '16px',fontWeight: 400,color: '#000',display: 'inline-block'}}>
                                                        {this.state.gift?this.state.gift.name:''}
                                                    </p>
                                                        <img style={{width: '50px',height: '50px',borderRadius: '50%',border:' 2px solid #117183'}} alt="" src={this.state.gift.img?this.state.gift.img[0]:require('../../assets/images/profileicon.jpg')}/>
                                                    </div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="2" xs="2">
                                                <br></br>
                                                <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                                    <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                                    onClick={()=>{this.props.history.push('giftInfo',{data:this.state.gift}) }}>
                                                    remove_red_eye
                                                    </span>
                                                    <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                                    onClick={()=>{this.props.history.push('giftInfo',{data:this.state.gift}) }}>
                                                    {allStrings.show}
                                                    </span> 
                                                </p>
                                                </MDBCol>
                                            </MDBRow>
                                            }
                                            {this.state.actionType ==="VIEW"&&this.state.occasion&&
                                            <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                                <MDBCol md="10" xs="10">
                                                    <div class="md-form">
                                                    <label htmlFor="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.occasion}</label>
                                                    <br></br>
                                                    <div style={{textAlign:this.props.isRTL?'right':'left'}}>
                                                    <p style={{borderBottom: '1px solid #dedede',width:'81%',padding:'10px',paddingBottom: '14px',fontSize: '16px',fontWeight: 400,color: '#000',display: 'inline-block'}}>
                                                        {this.state.occasion?this.state.occasion.name:''}
                                                    </p>
                                                        <img style={{width: '50px',height: '50px',borderRadius: '50%',border:' 2px solid #117183'}} alt="" src={this.state.occasion.img?this.state.occasion.img:require('../../assets/images/profileicon.jpg')}/>
                                                    </div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="2" xs="2">
                                                <br></br>
                                                <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                                    <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                                    onClick={()=>{this.props.history.push('occasionInfo',{data:this.state.occasion}) }}>
                                                    remove_red_eye
                                                    </span>
                                                    <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                                    onClick={()=>{this.props.history.push('occasionInfo',{data:this.state.occasion}) }}>
                                                    {allStrings.show}
                                                    </span> 
                                                </p>
                                                </MDBCol>
                                            </MDBRow>
                                            }
                                            {this.state.content&&this.state.type === "LOCATION"&&
                                            <MDBRow>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.latitude}</label>
                                                    <input  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.location[1]?this.state.location[1]:0}  type="number" step="0.01"  id="form65" name="latitude" className="form-control" required  validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form64" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.longitude}</label>
                                                    <input  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.location[0]?this.state.location[0]:0} type="number" step="0.01"  id="form64" name="longitude" className="form-control" required  validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            }
                                            {this.state.files&&this.state.type === "RECORD"&&
                                            <MDBRow>
                                                <MDBCol md="12">
                                                <label htmlFor="form920" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>
                                                    <span className='labelName'>{allStrings.record}</span>
                                                </label>
                                                {this.state.files.map((val,index)=>(
                                                    <div style={{width:"100%"}}>
                                                        <audio controls style={{width:"100%"}}>
                                                            <source src={val.link} type="audio/ogg"/>
                                                            <source src={val.link} type="audio/mpeg"/>
                                                            Your browser does not support the audio element.
                                                        </audio>
                                                    </div>
                                                ))}
                                                </MDBCol>
                                            </MDBRow>
                                            }
                                            {this.state.files&&this.state.type === "MUSIC"&&
                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <label htmlFor="form920" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>
                                                        <span className='labelName'>{allStrings.music}</span>
                                                    </label>
                                                    <div style={{width:"80%",margin:'auto'}}>
                                                        <img width="100%" height="350px" alt =" " src={this.state.media.image}/>
                                                        <p className='mediaName'>{this.state.media.name}</p>
                                                        <p className='artist'>{this.state.media.artist}</p>
                                                        <p className='year'>{moment(this.state.media.year).locale('en').format('y')}</p>
                                                        <audio controls style={{width:"100%"}}>
                                                            <source src={this.state.media.trackPreview} type="audio/mp4"/>
                                                            <source src={this.state.media.trackPreview} type="audio/mpeg"/>
                                                            Your browser does not support the audio element.
                                                        </audio>
                                                        
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            }
                                            {this.state.files&&this.state.type === "MOVIE"&&
                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <label htmlFor="form920" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>
                                                        <span className='labelName'>{allStrings.movie}</span>
                                                    </label>

                                                    <div style={{width:"80%",margin:'auto'}}>
                                                        <img width="100%" height="350px" alt =" " src={this.state.media.image}/>
                                                        <p className='mediaName'>{this.state.media.name}</p>
                                                        <p className='artist'>{this.state.media.artist}</p>
                                                        <p className='year'>{moment(this.state.media.year).locale('en').format('y')}</p>
                                                        {/* <video width="100%" height="300px" controls>
                                                            <source src={this.state.media.trackPreview} type="video/mp4"/>
                                                            <source src={this.state.media.trackPreview} type="video/ogg"/>
                                                            Your browser does not support the video tag.
                                                        </video> */}
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            }                   
                                            
                                            </div>
                                            <br></br>
                                            <br></br>
                                            <div className="text-center">
                                            {this.state.actionType ==="VIEW"&&
                                                <MDBBtn onClick={()=>{this.delete()}} rounded color="danger" className="btn-block z-depth-1a">
                                                    <MDBIcon icon="trash-alt" className="mr-2" />
                                                    {allStrings.remove}
                                                </MDBBtn>
                                            }
                                            </div>
                                        </form>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBContainer>
                            </CardContent>
                        </Card>
                    </div>
                </MDBCol> 
                {this.state.actionType==="VIEW"&&this.imageSection()}   
            </MDBRow>
      </MDBContainer>
      
    </div> 
  )
  }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  });
  
  const mapDispatchToProps = {
  };
  
  export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(postInfo)
  );